import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { SubServicesField } from './subservicesfield.model';

@Injectable({
  providedIn: 'root'
})
export class SubservicesfieldsService {

  constructor(private http: HttpClient, private global: Globle) {

  }


  getAll(subServiceId: number) {
    return this.http.get<SubServicesField[]>(this.global.APIURL +
      "subservicefields?subServiceId=" + subServiceId);
  }

  CreateUpdate(subservicefields: any) {
    console.log(subservicefields)
    return this.http.post(this.global.APIURL + "subservicefields", subservicefields)
  }
}
